import { AnyAction } from 'redux';
import { Currency } from '@synergy/models';

import { SETTINGS_UPDATE } from '../actions/settings-actions';
import { Settings } from '../models/settings';
import { SidebarPanels } from '../../features/activity-sidebar/sidebar-panels';

const initialSettingsReducerState: Settings = {
    sidebarCollapsed: false,
    activitySidebarCollapsed: false,
    selectedDetailPanel: SidebarPanels.Activities,
    apiBaseUrl: '',
    mediaBaseUrl: '',
    statusScale: null,
    currency: Currency.EUR,
    supportedCurrencies: [],
    pageSize: 10,
    ftpServer: '',
    sftpServer: '',
    privateFilesystemPath: '',
    isImpersonator: false,
};

export const settingsReducer = (state: Settings = initialSettingsReducerState, action: AnyAction): Settings => {
    const { type, settings } = action;
    switch (type) {
        case SETTINGS_UPDATE: {
            return {
                ...state,
                ...settings,
            };
        }
        default: {
            return state;
        }
    }
};
